export default __webpack_public_path__ + "static/media/blue-comments.8ac746f4.svg";